export default __webpack_public_path__ + "static/media/0xc56d17dd519e5eb43a19c9759b5d5372115220bd.d809d245.jpg";